var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMcLogoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 134.9 134.9",
    style: {
      enableBackground: "new 0 0 134.9 134.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#39C3EF;}\r\n\t.st1{fill:#F9CD38;}\r\n\t.st2{fill:#F83F54;}\r\n\t.st3{fill:#34B47D;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 67.4,
    cy: 14.5,
    r: 14.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 67.4,
    cy: 120.3,
    r: 14.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 14.5,
    cy: 67.4,
    r: 14.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 120.3,
    cy: 67.4,
    r: 14.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 30,
    cy: 104.8,
    r: 14.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 104.8,
    cy: 30,
    r: 14.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 104.8,
    cy: 104.8,
    r: 14.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 30,
    cy: 30,
    r: 14.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcLogoCircle);
export default __webpack_public_path__ + "static/media/mcLogoCircle.77d8287880111f1860befd597ecab4b2.svg";
export { ForwardRef as ReactComponent };